var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.6 45.6",
    style: {
      enableBackground: "new 0 0 124.6 45.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C68A0;}\n\t.st1{fill:#32324E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "93.3,18.2 96.2,18.2 94.6,24.6 98.9,24.6 98.2,27.2 91,27.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "101.9,18.2 99.6,27.2 102.7,27.2 105,18.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.1,27.2 106.3,18.2 112.9,18.2 112.5,19.9 108.7,19.9 108.2,21.9 112,21.9 111.5,23.7 107.8,23.6  106.9,27.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.1,27.2 55.8,27.2 57.5,20.3 60.5,20.3 61.1,18.2 52,18.2 51.4,20.3 54.7,20.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115.1,27.2 117.8,27.2 119.5,20.3 122.5,20.3 123.1,18.2 114,18.2 113.4,20.3 116.8,20.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "62.1,18.2 69.2,18.2 68.7,20 64.5,20 64.1,21.7 68.3,21.7 67.9,23.2 63.7,23.2 63.2,25.1 67.4,25.1  66.9,27.2 59.9,27.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,18.2h2.8c0,0-1,3.8-1.3,5.1c-0.5,2.1,2.4,2.3,2.8,0.8c0.4-1.5,1.5-5.9,1.5-5.9h2.8L40.7,24 c-0.9,4.7-9.1,3.8-8.4,0.1C32.9,20.4,33.5,18.2,33.5,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.7,18.2h2.8c0,0-0.9,3.8-1.3,5.1c-0.5,1.9,2.2,2.3,2.6,0.8c0.4-1.5,1.5-5.9,1.5-5.9h3L20.8,24 c-0.9,4.7-9.2,3.8-8.6,0C12.8,20.4,13.7,18.2,13.7,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,18.2H5.3l-5,9h3.5L4.7,25h3l0.2,2.3l2.9,0L9.7,18.2z M4.8,23.1L6.7,20h0.8l0.3,3.1H4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,20.4l0.4-1.6c0,0-5.3-1.7-6.6,0.4c-1.9,3,1.3,3.8,1.8,3.9c2.2,0.4,1.4,2.2-0.2,2.2c-1.9,0-3-0.5-3.2-0.5 l-0.4,1.6c0,0,6.5,2.6,7.2-2.1c0.5-3.2-3.6-1.8-3.6-3.7C45.6,18.8,50,20.4,50,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,19.9l0.4-1.7c0,0-7-0.6-8.4,3.2c-0.8,2.1-0.7,3.4,0.3,4.6c1.5,1.8,6.6,1.3,6.9-0.4 c0.1-0.7,0.1-1.4,0.1-1.9c0-0.1,0.1-0.1,0.2-0.1l0-0.5l-0.3-0.1l-2,0L28.3,25c0,0-3,0.9-3-1.3C25.1,19.8,29.8,19.7,31.2,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,29.1l2.7-11H72l-2.9,11h-8.8l9.2,16.4L86,29.1H77.2z M66.5,32.5h4.6l2.7-11.3h2.7l-2.7,11.3h4.7 l-7.8,7.8L66.5,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.4-0.2L73.9,16.2h8.8l-2.7,11h7.8l2.9-11h8.8L90.4-0.2z M88.9,13.2l-2.7,11.3h-2.7l2.7-11.3h-4.7l7.8-7.8 l4.2,7.8H88.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.e094353b5ce225c3ef98ccfab42a3351.svg";
export { ForwardRef as ReactComponent };